// Customer Register Debug
document.addEventListener('DOMContentLoaded', function() {
  const registerForm = document.querySelector('form[action*="account"]');
  
  if (registerForm) {
    console.log('Register form found:', registerForm);
    
    registerForm.addEventListener('submit', function(e) {
      console.log('Form submitted');
      
      // Form validasyonunu kontrol et
      const firstName = this.querySelector('input[name="customer[first_name]"]');
      const lastName = this.querySelector('input[name="customer[last_name]"]');
      const email = this.querySelector('input[name="customer[email]"]');
      const password = this.querySelector('input[name="customer[password]"]');
      
      const data = {
        firstName: firstName ? firstName.value : 'missing',
        lastName: lastName ? lastName.value : 'missing', 
        email: email ? email.value : 'missing',
        password: password ? password.value : 'missing',
        passwordLength: password ? password.value.length : 0
      };
      
      console.log('Form validation check:', data);
      
      // Validasyon kontrolü
      if (!data.email || !data.email.includes('@')) {
        console.error('Invalid email format');
      }
      if (data.passwordLength < 5) {
        console.error('Password too short (min 5 chars)');
      }
      if (!data.firstName) {
        console.error('First name missing');
      }
      if (!data.lastName) {
        console.error('Last name missing');
      }
    });
  }
  
  // Form submission sonrası hata yakalama
  window.addEventListener('load', function() {
    const errorMessages = document.querySelectorAll('.hdt-form__message--error, .hdt-form-message--error');
    if (errorMessages.length > 0) {
      console.log('Form errors found:', errorMessages);
      errorMessages.forEach(error => {
        console.log('Error message:', error.textContent);
      });
    }
  });
});